import { FC } from 'react';

import type { PsychicComponentInterface } from 'types/componentTypes';
import { getPsychicCtaButtons, getStatus } from 'lib/psychic.service';
import { PsychicCtaButtons } from 'entities/PsychicCtaButton';
import { HiatusBar } from 'entities/HiatusBar';
import { PsychicCharacteristic } from 'entities/PsychicCharacteristic';
import { useProfileLink } from 'src/shared/lib/psychics/hooks';
import { Text } from 'src/__generated__/graphqlTypes';
import { PsychicFeaturesArray } from 'entities/PsychicFeaturePallet';
import { PsychicCardStatusWrapper } from 'entities/PsychicCardStatusWrapper';
import { PsychicCardReadings } from 'entities/PsychicCardReadings';
import { PsychicCardHeading } from 'entities/PsychicCardHeading';

import styles from './PsychicCardTile.module.scss';
import MainImage from './MainImage';

const Card: FC<PsychicComponentInterface> = ({
  psychicSkeleton: psychicFrame,
  bootStatus,
  user,
  psychic,
  positionInArray,
}) => {
  const cta = getPsychicCtaButtons(psychic, psychicFrame, { hashedId: user?.hashedId });
  const linkProps = useProfileLink(psychicFrame, psychic, positionInArray);
  const moreText = (psychicFrame.extraTextsCollection?.items?.find((item) => item?.slug === 'more') || {}) as Text;
  const status = getStatus({
    chatStatus: psychic.chatStatus,
    phoneStatus: psychic.phoneStatus,
  });

  return (
    <li className={styles.card}>
      <MainImage
        psychic={psychic}
        psychicFrame={psychicFrame}
        positionInArray={positionInArray}
        linkProps={linkProps}
      />
      <PsychicCardHeading
        psychic={psychic}
        psychicFrame={psychicFrame}
        linkProps={linkProps}
      />
      <PsychicCardReadings
        psychic={psychic}
        psychicFrame={psychicFrame}
      />
      <PsychicFeaturesArray features={psychic.specialities} />
      <PsychicCharacteristic
        text={psychic.latestTestimonial}
        linkProps={linkProps}
        moreLabel={moreText?.text as string}
      />
      <PsychicCardStatusWrapper
        status={status}
        psychic={psychic}
        psychicFrame={psychicFrame}
      />
      {!psychic.onHiatus && (
        <PsychicCtaButtons
          shape="Oval"
          bootStatus={bootStatus}
          className={styles.interaction}
          chatButton={cta.chatButton}
          talkButton={cta.talkButton}
          inQueueButton={cta.inQueueButton}
          callbackButton={cta.callbackButton}
          messageButton={cta.messageButton}
          psychicFrame={psychicFrame}
          psychic={psychic}
        />
      )}
      <HiatusBar
        psychic={psychic}
        contentfulData={psychicFrame}
        className={styles.hiatus}
      />
    </li>
  );
};

export default Card;
